import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { registerComponent } from "./register.component";
import { HttpModule } from '@angular/http';
import { RouterModule } from "@angular/router";
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ValidateUsuario } from "./verificarUsuario.directive"
import { ShowHideInput, ShowHideInput2, ShowHideInput3 } from "./show-hide-input.directive"
import { ActivacionComponent } from "./activacion.component"
import { Ng2Bs3ModalModule } from "ng2-bs3-modal/ng2-bs3-modal";
import { CancelarRenunciaBeneficioComponent } from "./CancelarRenunciaBeneficio.component"

@NgModule({
    declarations: [registerComponent, ShowHideInput, ValidateUsuario, ActivacionComponent, ShowHideInput2, ShowHideInput3,CancelarRenunciaBeneficioComponent],
    imports: [BrowserModule, Ng2Bs3ModalModule, HttpModule, FormsModule, BrowserAnimationsModule, RouterModule]
})

export class RegisterModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/register/register.module.ts